module.exports = __webpack_public_path__ + "img/andy_live2.5dff5cab.jpeg";